import isEmpty from 'lodash/isEmpty';

import 'fomantic-ui-less/definitions/modules/transition.less';
import 'fomantic-ui-less/definitions/modules/dropdown.less';

import 'fomantic-ui-less/definitions/behaviors/api';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';
import {parseJSON, stringifyJSON} from './json';
import {decode} from 'html-entities';
import {urlData} from './urlData';
import jsonata from 'jsonata';
import {filterFields} from './formFields';

export const workflowDefinitionVersionsSelectDropdown = ({
                                                           element,
                                                           workflowDefinitionId,
                                                           value,
                                                           onChange = undefined,
                                                           clearable = true,
                                                           searchable = true,
                                                         }) => {
  const dropdown = $(element).dropdown({
    transition: 'scale',
    duration: 0,
    showNoResults: false,
    clearable,
    searchable,
    apiSettings: {
      url: `/api/workflow-definitions/${workflowDefinitionId}/versions`,
      cache: false,
      rawResponse: true,
      onResponse: summaryList => ({
        success: true,
        results: summaryList.filter(summary => summary.disabled !== true).map(summary => ({
          value: summary.version,
          name: `Version ${summary.version}`,
        })),
      }),
    },
    onChange,
    filterRemoteData: true,
    saveRemoteData: false,
  });

  if (!isEmpty(value)) {
    dropdown.dropdown('queryRemote', '', function() {
      dropdown.dropdown('set selected', value);
    });
  }

  return dropdown;
};

export const usersSearchDropdown = ({
                                      element,
                                      value,
                                      onChange = undefined,
                                      clearable = false,
                                      searchable = true,
                                    }) => {
  const dropdown = $(element).dropdown({
    transition: 'scale',
    duration: 0,
    clearable,
    searchable,
    showNoResults: false,
    apiSettings: {
      url: '/api/search/users?query={query}',
      onResponse: searchResponse => {
        const results = searchResponse.content.map(user => ({
          name: isEmpty(user.fullName) ? user.email : user.fullName,
          image: `/avatar/${user.id}`,
          imageClass: 'ui circular image icon icon-18',
          value: user.id,
        }));

        return {results};
      },
    },
    onChange
  });

  if (!isEmpty(value)) {
    dropdown.dropdown('queryRemote', value, function() {
      dropdown.dropdown('set selected', value);
    });
  }

  return dropdown;
};

export const setupDropdowns = element => {
  element.querySelectorAll('.ui.dropdown').forEach(el => {
    const settings = {
      duration: 0,
      forceSelection: false
    };

    if (el.classList.contains('additions')) {
      settings.allowAdditions = true;
    }

    if (el.classList.contains('search')) {
      settings.fullTextSearch = true;
    }

    if (el.classList.contains('clearable')) {
      settings.clearable = true;
    }

    const dataSettings = parseJSON(decode(el.getAttribute('data-settings')));
    if (dataSettings) {
      const {
        credentials,
        url,
        method,
        headers,
        data,
        resultSelectorJSONata,
      } = dataSettings?.api || {};

      if (!isEmpty(url)) {
        const isSimWorkflowApi = url.startsWith('/api/');

        settings.apiSettings = {
          cache: !isSimWorkflowApi,
          url: isSimWorkflowApi ? url : '/api/proxy',
          method: isSimWorkflowApi ? method : 'POST',
          beforeXHR: function(xhr, xhrSettings) {
            if (isSimWorkflowApi) {
              xhrSettings.data = data;

              if (!isEmpty(headers)) {
                Object.keys(headers).
                forEach(headerName => {
                  xhr.setRequestHeader(headerName,
                      headers[headerName]);
                });
              }
            } else {
              xhrSettings.data = stringifyJSON({
                credentials,
                url: urlData(url, this),
                method,
                headers,
                body: data,
                input: filterFields($(el.closest('.ui.form'))?.form('get values'))
              });
            }
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            return xhr;
          },
          onResponse: function(response) {
            if (isEmpty(resultSelectorJSONata)) {
              return response;
            } else {
              try {
                return {
                  results: jsonata(resultSelectorJSONata).evaluate(response).map(item => ({
                    ...item,
                    selected: item.selected === true || ['true', '1'].includes(item.selected)
                  })),
                };
              } catch (e) {
                return response;
              }
            }
          },
        };

        if (settings.fullTextSearch && !url?.includes('{query}')) {
          settings.filterRemoteData = true;
        }
      } else if (!isEmpty(dataSettings.values)) {
        settings.values = dataSettings.values.map(item => ({
          ...item,
          selected: item.selected === true || ['true', '1'].includes(item.selected)
        }));
      }
    }

    $(el).dropdown(settings);
  });
}